<template>
  <div class="layout-container">
    <div class="view-container">
      <v-row no-gutters class="mt-10">
        <v-col class="info-title" cols="12">
          <p class="font--m-1" style="line-height: 1.4">정보 등록 (2/2)</p>
          <p class="font--m-5 color--gray-80" style="line-height: 1.4">
            이제 다 왔어요! <br />
            정보만 입력하면, 회원가입이 끝나요!
          </p>
        </v-col>
      </v-row>
      <v-row no-gutters class="mb-10">
        <v-col cols="12">
          <p class="mb-1 font--m-5">대표자명</p>
          <v-text-field
            v-model="business.ownerName"
            solo
            single-line
            hide-details
            outlined
            flat
            :error="!!invalidMsg.ownerName"
            label="대표자명 입력"
          ></v-text-field>
          <ErrorText :text="invalidMsg.ownerName" nudgeLeft="4" />
          <p class="mt-5 mb-1 font--m-5">사업자명</p>
          <v-text-field
            v-model="business.name"
            solo
            single-line
            hide-details
            outlined
            flat
            :error="!!invalidMsg.name"
            label="사업자등록증 기재된 사업자명 입력"
          ></v-text-field>
          <ErrorText :text="invalidMsg.name" nudgeLeft="4" />
          <p class="mt-5 mb-1 font--m-5">사업자등록번호(10자리)</p>
          <v-text-field
            v-model="business.licenseNumber"
            solo
            single-line
            hide-details
            outlined
            flat
            :error="!!invalidMsg.licenseNumber"
            :rules="rules.licenseNumber"
            label="사업자등록번호 입력 ex.1112233333"
          ></v-text-field>
          <ErrorText :text="invalidMsg.licenseNumber" nudgeLeft="4" />
          <p class="mt-5 mb-1 font--m-5">사업자등록증</p>
          <v-file-input
            accept="image/*"
            v-model="business.licenseImage"
            label="파일 업로드 jpg,png"
            prepend-icon="mdi-cloud-upload"
            outlined
          >
          </v-file-input>
          <ErrorText :text="invalidMsg.licenseImage" nudgeLeft="4" />
        </v-col>
      </v-row>
      <v-row no gutters class="mb-10">
        <v-col cols="12">
          <BasicButton
            :disabled="!isValidAll"
            :loading="isLoading"
            @click="addBusiness(business)"
            id="btn__wV4IcDxa5UygZ26/ohJeTQ=="
          >
            정보 등록 완료하기!
          </BasicButton>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import Regex from '@/const/Regex'

export default {
  components: {},
  data() {
    return {
      business: {
        name: null,
        ownerName: null,
        licenseNumber: null,
        licenseImage: null,
      },
      isLoading: false,
      rules: {
        name: [(value) => !!value || '대표자명을 입력해주세요'],
        ownerName: [(value) => !!value || '사업자명을 입력해주세요'],
        licenseNumber: [
          (value) => !!value || '사업자등록번호를 입력해주세요',
          (value) => Regex.LICENSENUMBER.REGEX.test(value) || Regex.LICENSENUMBER.MSG,
        ],
        licenseImage: [(value) => !!value || '사업자등록증을 업로드해주세요'],
      },
      invalidMsg: {},
      nameIsValid: false,
      ownerNameIsValid: false,
      licenseNumberIsValid: false,
      licenseImageIsValid: false,
    }
  },
  computed: {
    isValidAll() {
      return (
        this.nameIsValid === true &&
        this.ownerNameIsValid === true &&
        this.licenseNumberIsValid === true &&
        this.licenseImageIsValid === true
      )
    },
  },
  watch: {
    'business.name'(v) {
      const msg = this.getFormErrMsg('name', v)
      this.nameIsValid = msg === null
    },
    'business.ownerName'(v) {
      const msg = this.getFormErrMsg('ownerName', v)
      this.ownerNameIsValid = msg === null
    },
    'business.licenseNumber'(v) {
      this.licenseNumberDuplicate(v)
    },
    'business.licenseImage'(v) {
      const msg = this.getFormErrMsg('licenseImage', v)
      this.licenseImageIsValid = msg === null
    },
    'isValidAll': {
      immediate: true,
      handler(v) {
        if (v === true) {
          this.$emit('update:business', this.business)
        } else {
          this.$emit('update:business', null)
        }
      },
    },
  },
  methods: {
    ...mapActions('business', {
      inputBusiness: 'addBusiness',
    }),
    ...mapActions('auth', ['getMe']),
    async addBusiness(business) {
      this.isLoading = true
      try {
        await this.inputBusiness(business)
        await this.getMe()
        this.$router.push('/my/register/complete')
      } finally {
        this.isLoading = false
      }
    },
    getFormErrMsg(type, newVal) {
      const rules = this.rules[type]
      let msg = null
      if (newVal) {
        for (let index = 0; index < rules.length; index++) {
          const rule = rules[index]
          const isValid = rule(newVal)
          if (typeof isValid !== 'boolean') {
            msg = isValid
            break
          }
        }
      }

      this.invalidMsg[type] = msg
      return msg
    },
    async licenseNumberDuplicate(licenseNumber) {
      const msg = this.getFormErrMsg('licenseNumber', licenseNumber)
      if (msg === null) {
        this.licenseNumberIsValid = true
      } else {
        this.licenseNumberIsValid = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.view-container {
  .info-title {
    text-align: center;
  }
}
</style>
